import ptBR from "../locales/pt-BR.json" with { type: "json" };
import es from "../locales/es.json" with { type: "json" };
import en from "../locales/en.json" with { type: "json" };

export const LOCALES = ["pt-BR", "es", "en"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "pt-BR";

export type MessageKey = keyof typeof ptBR;
export const catalogs: Record<Locale, Record<MessageKey, string>> = { "pt-BR": ptBR, es, en };

export function t(
  locale: Locale,
  key: MessageKey,
  vars: Record<string, string | number> = {},
): string {
  const raw = catalogs[locale][key] ?? catalogs[DEFAULT_LOCALE][key] ?? key;
  // "singular|plural": the first form when vars.count is 1.
  const forms = raw.split("|");
  const template =
    forms.length === 2 && typeof vars.count === "number"
      ? vars.count === 1
        ? forms[0]!
        : forms[1]!
      : raw;
  return template.replace(/\{(\w+)\}/g, (_, name: string) => String(vars[name] ?? `{${name}}`));
}
